import { compact } from 'lodash';

import { ScheduleFrequencyInterface, ScheduleFrequencyType } from '@/types';
import { RouteSequenceApiV4Interface, ScheduleFrequencyApiInterface } from '@/types/api-types';

export const getMainOptionSchedules = (mainOptions: RouteSequenceApiV4Interface[]): ScheduleFrequencyInterface => {
  let type = 'day' as ScheduleFrequencyType;

  const schedulesArr = mainOptions.reduce((acc, option) => {
    const { vehicles } = option.segments[0];

    if (vehicles) {
      const optionSchedules = vehicles.map((vehicle) => {
        const dailySchedules = vehicle.schedule;
        const weeklySchedules = vehicle.scheduleWeek;

        if (weeklySchedules) type = 'week';

        return dailySchedules || weeklySchedules;
      });
      return [...acc, ...compact(optionSchedules)];
    }
    return acc;
  }, [] as ScheduleFrequencyApiInterface[]);

  return {
    type,
    frequency: combineScheduleFrequency(schedulesArr),
  };
};

const combineScheduleFrequency = (schedules: ScheduleFrequencyApiInterface[]): ScheduleFrequencyApiInterface => {
  return schedules.reduce((acc, obj) => {
    const merge = { ...acc };

    Object.keys(obj).forEach((key) => {
      if (merge[key]) {
        merge[key] += obj[key];
      } else {
        merge[key] = obj[key];
      }
    });

    return merge;
  }, {} as ScheduleFrequencyApiInterface);
};
